import i18n from '@/utils/i18n';
import React, { useRef } from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { EditOrderItemNoteContent } from '@/components/orders/edit-order-item-note-content';
import { EditOrderItemNoteParams } from '@/navigators/types';
import { SCREEN_PADDING } from '@/styles';
import { StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

type Props = EditOrderItemNoteParams & {
  onClose: () => void;
};

export const EditOrderItemNoteActionSheet: React.FC<Props> = ({
  initialNotes,
  onClose,
  onNotesSaved,
  variantPackUUID,
}) => {
  const { bottom } = useSafeAreaInsets();
  const closeHandlerRef = useRef<() => void>(onClose);

  const handleClose = () => {
    closeHandlerRef.current();
  };

  return (
    <BaseActionSheet
      contentStyle={styles.actionSheetContentStyle}
      isVisible
      onClose={handleClose}
      showCloseButton
      title={i18n.t('item_note')}
    >
      <EditOrderItemNoteContent
        contentContainerStyle={{ paddingBottom: bottom }}
        initialNotes={initialNotes}
        onClose={onClose}
        onNotesSaved={onNotesSaved}
        onRegisterCloseHandler={(handler) => {
          closeHandlerRef.current = handler;
        }}
        variantPackUUID={variantPackUUID}
      />
    </BaseActionSheet>
  );
};

const styles = StyleSheet.create({
  actionSheetContentStyle: {
    paddingHorizontal: SCREEN_PADDING,
    paddingTop: 0,
  },
});
